import React from 'react';
import { Button, Stack } from '@mui/material';
import { Fab } from '@marageti/z4-lib';

type RemindersActionBarProps = {
  onNewReminder: () => void;
};

const RemindersActionBar = ({
  onNewReminder,
}: RemindersActionBarProps) => (
  <Fab anchorId="oryx-footer">
    <Stack direction="row" spacing={1.5}>
      <Button
        variant="contained"
        onClick={onNewReminder}
      >
        New Reminder
      </Button>
    </Stack>
  </Fab>
);

export default RemindersActionBar;
